// ═══════════════════════════════════════════════════════════════════════════════
// Consent Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from '../constants/index.js';
// ── Consent Accept Input Schema ──
export const consentAcceptInputSchema = z.object({
    locale: z.enum(SUPPORTED_LANGUAGES, {
        message: 'Locale must be a supported language',
    }),
});
//# sourceMappingURL=consent.schema.js.map